import { render, staticRenderFns } from "./UrunSepetTur.vue?vue&type=template&id=2c8b5266&scoped=true"
import script from "./UrunSepetTur.vue?vue&type=script&lang=js"
export * from "./UrunSepetTur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b5266",
  null
  
)

export default component.exports